export enum HttpStatusCodes {
  OK = 200,
  CREATED = 201,
  NO_CONTENT = 204,
  SEE_OTHER = 303,
  NOT_MODIFIED = 304,
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  NOT_ACCEPTABLE = 406,
  UNPROCESSABLE_ENTITY = 422,
  TOO_MANY_REQUESTS = 429,
  SERVER_ERROR = 500,
  BAD_GATEWAY = 502
}

export enum FileTypes {
  EXCEL = '.xls,.xlsx,.xlsm,.xml, application/vnd.ms-excel, apadsheetml.sheet, application/vnd.ms-excel.sheet.macroenabled.12'
}

export const CONTENT_DISPOSITION_HEADER = 'Content-disposition';
